module.exports = __webpack_public_path__ + "static/img/20.2f86545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/20.png
// module id = NsR5
// module chunks = 0